import { lazy } from 'react';
import { createRoute } from './utils';

// Lazy load policy rules components
const CategoryDetailPage = lazy(() => import('@/pages/rules/CategoryDetailPage'));
const CategoryEditPage = lazy(() => import('@/pages/rules/CategoryEditPage'));
const RuleSetDetailPage = lazy(() => import('@/pages/rules/RuleSetDetailPage'));
const RuleSetEditPage = lazy(() => import('@/pages/rules/RuleSetEditPage'));
const RuleSetExamplesPage = lazy(() => import('@/pages/rules/RuleSetExamplesPage'));
const RuleSetExamplesEditPage = lazy(() => import('@/pages/rules/RuleSetExamplesEditPage'));
const GuardrailDetailPage = lazy(() => import('@/pages/rules/GuardrailDetailPage'));
const GuardrailEditPage = lazy(() => import('@/pages/rules/GuardrailEditPage'));
const PreviewPage = lazy(() => import('@/pages/rules/PreviewPage'));
const RulesConfigurationPage = lazy(() => import('@/pages/rules/RulesConfigurationPage'));

// Rules nested routes (hidden from navigation)
export const rulesNestedRoutes = [
  createRoute('rules/category/new', <CategoryEditPage />, 'New Category', undefined, { hidden: true }),
  createRoute('rules/category/:categoryId', <CategoryDetailPage />, 'Category Details', undefined, {
    hidden: true,
  }),
  createRoute('rules/category/:categoryId/edit', <CategoryEditPage />, 'Edit Category', undefined, {
    hidden: true,
  }),
  createRoute('rules/category/:categoryId/ruleset/new', <RuleSetEditPage />, 'New Ruleset', undefined, {
    hidden: true,
  }),
  createRoute('rules/category/:categoryId/ruleset/:ruleSetId', <RuleSetDetailPage />, 'Ruleset Details', undefined, {
    hidden: true,
  }),
  createRoute('rules/category/:categoryId/ruleset/:ruleSetId/edit', <RuleSetEditPage />, 'Edit Ruleset', undefined, {
    hidden: true,
  }),
  createRoute(
    'rules/category/:categoryId/ruleset/:ruleSetId/examples',
    <RuleSetExamplesPage />,
    'Ruleset Examples',
    undefined,
    { hidden: true }
  ),
  createRoute(
    'rules/category/:categoryId/ruleset/:ruleSetId/examples/:exampleId',
    <RuleSetExamplesEditPage />,
    'Edit Example',
    undefined,
    { hidden: true }
  ),
  createRoute(
    'rules/category/:categoryId/ruleset/:ruleSetId/guardrail/new',
    <GuardrailEditPage />,
    'New Guardrail',
    undefined,
    { hidden: true }
  ),
  createRoute(
    'rules/category/:categoryId/ruleset/:ruleSetId/guardrail/:guardrailId',
    <GuardrailDetailPage />,
    'Guardrail Details',
    undefined,
    { hidden: true }
  ),
  createRoute(
    'rules/category/:categoryId/ruleset/:ruleSetId/guardrail/:guardrailId/edit',
    <GuardrailEditPage />,
    'Edit Guardrail',
    undefined,
    { hidden: true }
  ),
  createRoute(
    'rules/category/:categoryId/ruleset/:ruleSetId/guardrail/:guardrailId/examples',
    <GuardrailDetailPage />,
    'Guardrail Examples',
    undefined,
    { hidden: true }
  ),
  createRoute('rules/preview', <PreviewPage />, 'Preview & Generate', undefined, { hidden: true }),
  createRoute('rules/legacy', <RulesConfigurationPage />, 'Legacy Rules', undefined, { hidden: true }),
];
